import { QuoteOptInDiscountOutput } from "./QuoteOptInDiscountOutput";
import QuoteProductCalculationResult from "./quoteProductCalculationResult";

export class QuotePricingOutput {
    constructor(item) {
        if (item) {
            this.products = item.products.map((x) => new QuoteProductCalculationResult(x));
            this.customLineItems = item.customLineItems.map((x) => new QuoteProductCalculationResult(x));
            this.optInDiscounts = item.optInDiscounts.map((x) => new QuoteOptInDiscountOutput(x));
        }
    }
}
